
sap["ls"]["preload"]["UCF_ResizeEventHelper"] = function() {/* global UCF_Object */
/// <reference path="../../core/Object.js"/>
/* global _assert, _trace, DEBUG */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_Cache */
/// <reference path="../../core/util/Cache.js"/>
/* global UCF_UserAgent */
/// <reference path="../../core/util/UserAgent.js"/>

/**
 * @typedef {Object} ResizeObserver
 * @property {function(HTMLElement|SVGElement): void} observe
 * @property {function(HTMLElement|SVGElement): void} unobserve
 */
/**
 * @typedef {Object} ResizeObserverEntry
 * @property {HTMLElement|SVGElement} target
 * @property {ResizeObserverSize[]} borderBoxSize
 * @property {ResizeObserverSize[]} contentBoxSize
 * @property {ResizeObserverSize[]} devicePixelContentBoxSize
 * @property {DOMRect} contentRect
 */
/**
 * @typedef {Object} ResizeObserverSize
 * @property {number} blockSize
 * @property {number} inlineSize
 */
/** @typedef {{oDomRef: HTMLElement, iWidth: number, iHeight: number}} ResizeElement */

/**
 * @param {function(Event): void} fHandler the event handler function
 */
function UCF_ResizeEventHelper(fHandler) {if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["UCF_ResizeEventHelper"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof fHandler === 'function', "typeof fHandler === 'function'", "ResizeEventHelper.js(38): UCF_ResizeEventHelper"); };

	/** @type {function(Event): void} */
	this["fHandler"] = fHandler;
	/** @type {Array.<ResizeElement>} */
	this["aResizeElementsIntervalCheck"] = [];
	/** @type {string} */
	this["sInterval"] = null;
	/** @type {boolean} */
	this["bActive"] = true;
	/** @type {boolean} */
	this["bSkipped"] = false;
	/** @type {Object<string,{width:number,height:number}>} */
	this["oLastKnownSizes"] = {};
	/** @type {UCF_Cache} */
	this["oCache"] = new (UCF_ClassLoader["oGetClass"]("UCF_Cache"))();

};window["UCF_ResizeEventHelper"] = UCF_ResizeEventHelper; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_ResizeEventHelper"); UCF_ResizeEventHelper["_"] = {UCF_ResizeEventHelper: 0}; }; ;
UCF_ResizeEventHelper["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_Object"))(); UCF_ResizeEventHelper.prototype["sClassName"] = "UCF_ResizeEventHelper";

/** @override */
UCF_ResizeEventHelper["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["destroy"]++; }; 
	this["fHandler"] = null;
	this["sInterval"] = null;
	this["oLastKnownSizes"] = null;
	if (this["oCache"]) {
		this["oCache"]["destroy"]();
		this["oCache"] = null;
	}

	UCF_Object.prototype["destroy"]["apply"](this, arguments);
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["destroy"] = 0; };

/** @param {HTMLElement} oDomRef the DOM reference */
UCF_ResizeEventHelper["prototype"]["attachEvent"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["attachEvent"]++; }; 
	if (oDomRef) {
		if (UCF_UserAgent["bIsIE"]()) {
			this["attachEventIntervalCheck"](oDomRef);
		} else {
			if (!oDomRef["offsetParent"]) {
				this["oLastKnownSizes"][UCF_DomUtil["sSerializeDomRef"](oDomRef)] = {
					"width": -1,
					"height": -1
				};
			}
			this["oGetResizeObserver"]()["observe"](oDomRef);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["attachEvent"] = 0; };

/**
 * Allows a control that has attached a DomRef to reset the current
 * width/height values (and 'skip' one check-interval) so it will not receive a
 * resize event that is cause by its own changes to its own DOM.
 * @param {HTMLElement} oDomRef the DOM reference
 * @param {UCF_Control} oControl the control instance doing the call
 */
UCF_ResizeEventHelper["prototype"]["reset"] = function(oDomRef, oControl) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["reset"]++; }; 
	if (this["detachEvent"](oDomRef)) {
		UCF_JsUtil["delayedCall"](
			this["I_INTERVAL"],
			this,
			'reAttach',
			[oDomRef, oControl]
		);
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["reset"] = 0; };

/**
 * @private
 * @param {HTMLElement} oDomRef the DOM reference
 * @param {UCF_Control} oControl the control instance doing the call
 */
UCF_ResizeEventHelper["prototype"]["reAttach"] = function(oDomRef, oControl) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["reAttach"]++; }; 
	if (!oControl["bIsDestroyed"]) {
		this["attachEvent"](oDomRef);
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["reAttach"] = 0; };

/**
 * Detach resize event
 *
 * @param {HTMLElement} oDomRef the DOM reference
 * @return {boolean|undefined} Whether the DOM reference was found and removed
 * from the internal registry (if resize event 'emulation' is used).
 */
UCF_ResizeEventHelper["prototype"]["detachEvent"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["detachEvent"]++; }; 
	if (oDomRef) {
		if (UCF_UserAgent["bIsIE"]()) {
			return this["detachEventIntervalCheck"](oDomRef);
		} else if (this["oCache"]["has"]('oResizeObserver')) {
			this["oGetResizeObserver"]()["unobserve"](oDomRef);
			delete this["oLastKnownSizes"][UCF_DomUtil["sSerializeDomRef"](oDomRef)];
		}
	}

	return null;
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["detachEvent"] = 0; };

/**
 * @private
 * @param {ResizeElement} oResizeElement the stored information for the dom ref
 * @param {HTMLElement} oDomRef the current dom ref
 * @return {boolean} `true` if the dimensions of oDomRef did change, otherwise
 * `false`
 */
UCF_ResizeEventHelper["prototype"]["bIsResized"] = function(oResizeElement, oDomRef) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["bIsResized"]++; }; 
	return oResizeElement["iWidth"] !== oDomRef["offsetWidth"]
		|| oResizeElement["iHeight"] !== oDomRef["offsetHeight"];
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["bIsResized"] = 0; };

/**
 * Create pseudo DOM event
 *
 * @param {element} oDomRef the dom reference
 * @return {Event} a pseudo DomEvent
 */
UCF_ResizeEventHelper["prototype"]["oCreatePseudoEvent"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["oCreatePseudoEvent"]++; }; 
	return {
		"type": 'resize',
		"target": oDomRef,
		"currentTarget": oDomRef,
		"bubbles": true,
		"cancelable": true,
		"isTrusted": true
	};
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["oCreatePseudoEvent"] = 0; };

// #region interval checking method ===========================================

/**
 * The interval which is used for checking the width/height of all attached
 * elements
 * @type {number}
 */
UCF_ResizeEventHelper["prototype"]["I_INTERVAL"] = 200;

/**
 * adds oDomRef to the list of DOM elements that get their resize events via
 * event emulation (i.e. interval checks)
 * @private
 * @param {HTMLElement} oDomRef the DOM reference
 */
UCF_ResizeEventHelper["prototype"]["attachEventIntervalCheck"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["attachEventIntervalCheck"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef, "oDomRef", "ResizeEventHelper.js(182): attachEventIntervalCheck"); };
	if (__UCF_TRACE__) { UCF_Tracer.trace(DEBUG, 'attaching resize for oDomRef.id = ' + oDomRef["id"], "ResizeEventHelper.js(183): attachEventIntervalCheck"); };

	// Add element to the list
	this["aResizeElementsIntervalCheck"]["push"]({
		"oDomRef": oDomRef,
		"iWidth": oDomRef["offsetWidth"],
		"iHeight": oDomRef["offsetHeight"]
	});

	// If interval is not already running, start it
	if (!this["sInterval"]) {
		this["sInterval"] = UCF_JsUtil["intervalCall"](
			this["I_INTERVAL"],
			this,
			'checkSizes'
		);
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["attachEventIntervalCheck"] = 0; };

/**
 * @param {HTMLElement} oDomRef the DOM reference
 * @return {boolean} `true` if the DOM reference has been removed successfully,
 * otherwise `false`
 */
UCF_ResizeEventHelper["prototype"]["detachEventIntervalCheck"] = function(oDomRef) {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["detachEventIntervalCheck"]++; }; 
	/** @type {boolean} */
	var bRemoved = false;
	/** @type {ResizeElement} */
	var oResizeElement;
	/** @type {number} */
	var i = 0;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef, "oDomRef", "ResizeEventHelper.js(215): detachEventIntervalCheck"); };

	// find entry in the array
	for (; i < this["aResizeElementsIntervalCheck"]["length"]; i++) {
		oResizeElement = this["aResizeElementsIntervalCheck"][i];

		if (oResizeElement["oDomRef"] === oDomRef) {
			this["aResizeElementsIntervalCheck"]["splice"](i, 1);
			bRemoved = true;
			break;
		}
	}

	// if list is empty now, stop interval
	if (this["aResizeElementsIntervalCheck"]["length"] === 0) {
		UCF_JsUtil["clearIntervalCall"](this["sInterval"]);
		this["sInterval"] = null;
	}

	return bRemoved;
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["detachEventIntervalCheck"] = 0; };

/**
 * Check sizes of resize elements
 */
UCF_ResizeEventHelper["prototype"]["checkSizes"] = function() {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["checkSizes"]++; }; 
	/** @type {ResizeElement} */
	var oResizeElement;
	/** @type {HTMLElement} */
	var oDomRef;
	/** @type {number} */
	var i = 0;

	for (; i < this["aResizeElementsIntervalCheck"]["length"]; i++) {
		oResizeElement = this["aResizeElementsIntervalCheck"][i];
		oDomRef = oResizeElement["oDomRef"];

		if (this["bIsResized"](oResizeElement, oDomRef)) {
			oResizeElement["iWidth"] = oDomRef["offsetWidth"];
			oResizeElement["iHeight"] = oDomRef["offsetHeight"];

			if (this["bActive"]) {
				this["fHandler"](this["oCreatePseudoEvent"](oDomRef));
			}
		}
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["checkSizes"] = 0; };

/**
 * Skip resize event emulation
 * @private
 */
UCF_ResizeEventHelper["prototype"]["skipResizeEventEmulation"] = function() {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["skipResizeEventEmulation"]++; }; 
	if (this["sInterval"]) {
		UCF_JsUtil["clearIntervalCall"](this["sInterval"]);
		this["sInterval"] = null;
		this["bSkipped"] = true;
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["skipResizeEventEmulation"] = 0; };

/**
 * Continue resize event emulation
 * @private
 */
UCF_ResizeEventHelper["prototype"]["continueResizeEventEmulation"] = function() {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["continueResizeEventEmulation"]++; }; 
	if (!this["sInterval"] && this["bSkipped"]) {
		this["sInterval"] = UCF_JsUtil["intervalCall"](
			this["I_INTERVAL"],
			this,
			'checkSizes'
		);
		this["bSkipped"] = false;
	}
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["continueResizeEventEmulation"] = 0; };
// #endregion
// #region resize observer ====================================================

/** @return {ResizeObserver} */
UCF_ResizeEventHelper["prototype"]["oGetResizeObserver"] = function() {;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["oGetResizeObserver"]++; }; 
	/** @type {UCF_ResizeEventHelper} */
	var self = this;

	return this["oCache"]["get"]('oResizeObserver', function() {
		return new window["ResizeObserver"](function( /** @type {ResizeObserverEntry[]} */ aEntries) {
			UCF_JsUtil["forEach"](aEntries, function(oEntry) {
				/** @type {string} */
				var sTargetId = UCF_DomUtil["sSerializeDomRef"](oEntry["target"]);
				/** @type {DOMRect} */
				var oContentRect = oEntry["contentRect"];

				if (sTargetId in self["oLastKnownSizes"]) {
					if (
						self["oLastKnownSizes"][sTargetId]["width"] !== oContentRect["width"] ||
						self["oLastKnownSizes"][sTargetId]["height"] !== oContentRect["height"]
					) {
						self["oLastKnownSizes"][sTargetId] = {
							"width": oContentRect["width"],
							"height": oContentRect["height"]
						};
						self["fHandler"](self["oCreatePseudoEvent"](oEntry["target"]));
					}
				} else {
					self["oLastKnownSizes"][sTargetId] = {
						"width": oContentRect["width"],
						"height": oContentRect["height"]
					};
				}
			});
		});
	});
};;if (__UCF_COVERAGE__) { UCF_ResizeEventHelper["_"]["oGetResizeObserver"] = 0; };

// #endregion

};